import React, { useEffect, useState } from "react";
import fetchBase from "../utils/fetchBase";

const buildCalendarWeeks = (periodStart, periodEnd, shifts) => {
    const start = new Date(periodStart + "T12:00:00");
    const end = new Date(periodEnd + "T12:00:00");

    const firstSunday = new Date(start);
    firstSunday.setDate(firstSunday.getDate() - firstSunday.getDay());

    const shiftsByDate = {};
    shifts.forEach(s => { shiftsByDate[s.date] = s; });

    const weeks = [];
    let cursor = new Date(firstSunday);

    while (cursor <= end) {
        const week = [];
        for (let i = 0; i < 7; i++) {
            const dateStr = `${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, "0")}-${String(cursor.getDate()).padStart(2, "0")}`;
            const inPeriod = cursor >= start && cursor <= end;
            week.push({
                date: new Date(cursor),
                dateStr,
                inPeriod,
                shift: inPeriod ? shiftsByDate[dateStr] : null
            });
            cursor.setDate(cursor.getDate() + 1);
        }
        weeks.push(week);
    }
    return weeks;
};

const formatTime = (t) => {
    if (!t) return "";
    return new Date(`1970-01-01T${t}`).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
};

const formatPeriodDate = (d, withYear = true) => {
    if (!d) return "";
    const [y, m, day] = d.split("-");
    return withYear ? `${m}/${day}/${y}` : `${m}/${day}`;
};

const TimesheetView = ({ timesheetId, mode = "live", onLoad }) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const authHeader = "Bearer " + localStorage.getItem("jwt_token");
        fetch(`${fetchBase}/time-log/timesheet/${timesheetId}`, {
            headers: { Authorization: authHeader }
        })
            .then(res => res.json())
            .then(d => { setData(d); if (onLoad) onLoad(d); })
            .catch(err => console.error("Failed to fetch timesheet:", err));
    }, [timesheetId]);

    if (!data) return <p style={{ padding: "40px", color: "#6e6e73" }}>Loading...</p>;

    const isLive = mode === "live";
    const weeks = buildCalendarWeeks(data.payPeriodStart, data.payPeriodEnd, data.shifts);
    const dayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        const cellStyle = { border: "1px solid #000", padding: "3px 4px", fontSize: "10px", textAlign: "center", verticalAlign: "top", whiteSpace: "nowrap" };
    const labelCellStyle = { ...cellStyle, fontWeight: 700, textAlign: "left", background: "#f2f2f2" };

    return (
                <div style={{ maxWidth: "850px", margin: "0 auto", padding: "16px", fontFamily: "Arial, sans-serif", color: "#000", background: "#fff" }}>
                <div style={{ textAlign: "center", borderBottom: "2px solid #000", paddingBottom: "8px", marginBottom: "12px" }}>
                    <h1 style={{ fontSize: "20px", margin: 0, letterSpacing: "2px" }}>{(data.adminOrganizationName || "").toUpperCase()}</h1>
                    <p style={{ fontSize: "12px", margin: "4px 0 0", fontStyle: "italic" }}>{data.adminAddress || ""}</p>
                </div>

            <p style={{ textAlign: "center", fontSize: "13px", fontWeight: 600, margin: "0 0 16px" }}>
                NON-Skilled Care for North Texas VA Veterans
            </p>

            <table style={{ width: "100%", fontSize: "12px", marginBottom: "12px" }}>
                <tbody>
                    <tr>
                        <td style={{ padding: "3px 0" }}><strong>NAME:</strong> {data.clientName}</td>
                        <td style={{ padding: "3px 0" }}><strong>Last 4 of Social:</strong> {data.clientSsnLastFour || "____"}</td>
                        <td style={{ padding: "3px 0" }}><strong>Phone:</strong> {data.clientPhone || "____"}</td>
                    </tr>
                    <tr>
                        <td colSpan={2} style={{ padding: "3px 0" }}><strong>Address:</strong> {data.clientAddress || "____"}</td>
                        <td style={{ padding: "3px 0" }}><strong>DOB:</strong> {data.clientDob || "____"}</td>
                    </tr>
                </tbody>
            </table>

                <div style={{ overflowX: "auto", marginBottom: "12px", WebkitOverflowScrolling: "touch" }}>
                    <table style={{ width: "100%", minWidth: "600px", border: "1px solid #000", borderCollapse: "collapse", fontSize: "12px" }}>
                        <tbody>
                            <tr>
                                <td style={{ ...cellStyle, textAlign: "left", whiteSpace: "nowrap" }} colSpan={4}>
                                    Approved Tasks: ☐ Bathing ☐ Dressing ☐ Toileting ☐ Transfer ☐ Walking ☐ Feeding ☐ Cleaning ☐ Meal Prep
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                    <p style={{ fontSize: "12px", marginBottom: "12px" }}>
                        <strong>Month & Year of Service :</strong>{" "}
                        <span style={{ fontSize: "17px", fontWeight: 700 }}>
                                {formatPeriodDate(data.payPeriodStart, false)} – {formatPeriodDate(data.payPeriodEnd)}
                        </span>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <strong>Total weekly Hours of services: HHA:</strong> {data.assignedHours ?? "____"}
                    </p>

            {weeks.map((week, wi) => {
                const lastInPeriodIndex = week.reduce((acc, d, idx) => (d.inPeriod ? idx : acc), -1);
                const firstInPeriodIndex = week.findIndex(d => d.inPeriod);
                const visibleWeek = lastInPeriodIndex >= 0 ? week.slice(firstInPeriodIndex, lastInPeriodIndex + 1) : week;
                const weekTotal = isLive ? week.reduce((sum, d) => sum + (d.shift?.totalHours || 0), 0).toFixed(2) : "";
                    return (
                        <div key={wi} style={{ overflowX: "auto", marginBottom: "6px", WebkitOverflowScrolling: "touch" }}>
                        <table style={{ width: "100%", minWidth: "600px", border: "1px solid #000", borderCollapse: "collapse" }}>
                        <tbody>
                            <tr>
                                <td style={labelCellStyle}>Day of the Month</td>
                                {visibleWeek.map((d, i) => (
                                    <td key={i} style={cellStyle}>
                                        {d.inPeriod ? `${dayLabels[d.date.getDay()]}: ${String(d.date.getMonth() + 1).padStart(2, "0")}/${String(d.date.getDate()).padStart(2, "0")}` : ""}
                                    </td>
                                ))}
                                <td style={labelCellStyle} rowSpan={5}>
                                    Total
                                    <div style={{ fontWeight: 700, fontSize: "14px", marginTop: "6px" }}>{weekTotal}</div>
                                </td>
                            </tr>
                            <tr>
                                <td style={labelCellStyle}>Time In</td>
                                {visibleWeek.map((d, i) => <td key={i} style={cellStyle}>{isLive && d.shift ? formatTime(d.shift.clockIn) : ""}</td>)}
                            </tr>
                            <tr>
                                <td style={labelCellStyle}>Time Out</td>
                                {visibleWeek.map((d, i) => <td key={i} style={cellStyle}>{isLive && d.shift ? formatTime(d.shift.clockOut) : ""}</td>)}
                            </tr>
                            <tr>
                                <td style={labelCellStyle}>Total</td>
                                {visibleWeek.map((d, i) => <td key={i} style={cellStyle}>{isLive ? (d.shift?.totalHours ?? "") : ""}</td>)}
                            </tr>
                            <tr>
                                <td style={labelCellStyle}>Veteran Initials</td>
                                {visibleWeek.map((d, i) => (
                                    <td key={i} style={{ ...cellStyle, height: "30px" }}>
                                        {isLive && d.shift?.veteranInitial && (
                                            <img src={d.shift.veteranInitial} alt="initial" style={{ maxHeight: "22px", maxWidth: "100%" }} />
                                        )}
                                    </td>
                                ))}
                            </tr>
                            </tbody>
                                </table>
                                </div>
                            );
                        })}

            <p style={{ fontSize: "10px", fontStyle: "italic", margin: "10px 0" }}>
                I agree that the time above was provided as represented in the above table. Do not sign if the time is not reflected correctly.
            </p>

            <table style={{ width: "100%", fontSize: "12px", marginTop: "14px" }}>
                <tbody>
                    <tr>
                        <td style={{ padding: "6px 0", width: "50%" }}>
                            <strong>Veteran Signature:</strong>{" "}
                            {isLive && data.veteranFinalSignature ? (
                                <img src={data.veteranFinalSignature} alt="veteran signature" style={{ maxHeight: "30px" }} />
                            ) : (
                                <span style={{ borderBottom: "1px solid #000", display: "inline-block", width: "180px" }}>&nbsp;</span>
                            )}
                        </td>
                        <td style={{ padding: "6px 0" }}>
                            <strong>Date:</strong>{" "}
                            <span style={{ borderBottom: "1px solid #000", display: "inline-block", width: "100px" }}>
                                {isLive ? (data.employeeSignedDate || "") : ""}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "6px 0" }}>
                            <strong>Attendant Name:</strong> {data.employeeName}
                        </td>
                        <td style={{ padding: "6px 0" }}>
                            <strong>Attendant Signature:</strong>{" "}
                            {isLive && data.employeeSignature ? (
                                <img src={data.employeeSignature} alt="employee signature" style={{ maxHeight: "30px" }} />
                            ) : (
                                <span style={{ borderBottom: "1px solid #000", display: "inline-block", width: "150px" }}>&nbsp;</span>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "6px 0" }}>
                            <strong>Name of Agency Rep.:</strong>{" "}
                            <span style={{ borderBottom: "1px solid #000", display: "inline-block", width: "150px" }}>
                                {isLive ? (data.agencyRepName || "") : ""}
                            </span>
                        </td>
                        <td style={{ padding: "6px 0" }}>
                            <strong>Signature:</strong>{" "}
                            {isLive && data.agencyRepSignature ? (
                                <img src={data.agencyRepSignature} alt="agency rep signature" style={{ maxHeight: "30px" }} />
                            ) : (
                                <span style={{ borderBottom: "1px solid #000", display: "inline-block", width: "150px" }}>&nbsp;</span>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default TimesheetView;